import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot} from '@angular/router';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

import {AppState} from '../store/core.state';
import {authLogoutSuccess, authRedirect} from '../store/auth/auth.actions';
import {AUTH_ACCESS_TOKEN} from '../models';
import {LocalStorageService} from '../services';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private store: Store<AppState>, private localStorageService: LocalStorageService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const accessToken = this.localStorageService.getItem(AUTH_ACCESS_TOKEN);
    return this.store.pipe(
      map(() => {
        if (accessToken) {
          return true;
        } else {
          this.store.dispatch(authLogoutSuccess({isLoading: false}));
          this.store.dispatch(authRedirect({url: '/features/login'}));
          return false;
        }
      })
    );
  }
}
